import {config} from "../environment";
import {useAsync} from "../utils/utils";

export type SakStatus = 'TILBUD' | 'GODTATT' | 'IKKE_BESVART' | 'AVVIST' | 'PLASSERT' | 'UKJENT'

export type PlassSakInfo = {
  id: number
  barnNavn: string
  barnIdent: string
  frist: string | null
  dato: string
  type: 'SØKNAD' | 'TILBUD' | 'OPPSIGELSE' | 'PERMISJONSSØKNAD'
  status: SakStatus
  title: string
}

type SakInfoResponse = {
  saker: Array<PlassSakInfo>
}

async function getAktivePlassSaker(): Promise<Array<PlassSakInfo>> {
  return fetch(`${config.apiUrl}/api/barnehageplass/aktive-saker`)
  .then(res => res.json() as Promise<SakInfoResponse>)
  .then(json => json.saker)
}

export const useGetAktivePlassSaker = useAsync(getAktivePlassSaker)

async function getAvsluttedePlassSaker(): Promise<Array<PlassSakInfo>> {
  return fetch(`${config.apiUrl}/api/barnehageplass/avsluttede-saker`)
  .then(res => res.json() as Promise<SakInfoResponse>)
  .then(json => json.saker)
}

export const useGetAvsluttedePlassSaker = useAsync(getAvsluttedePlassSaker)
